import React from 'react';
import Header from "./header/Header";
import MobileBottomBar from "./header/mobileBottomBar";
import About from "./about/About";
import LizingFinance from "./lizing/LizingFinance";
import Contacts from "./about/Contacts";
import {News, NewsPreview} from "./news/News";
import Main from "./Main";
import "../css/fonts.css"
import "../css/colorsConstants.css"
import {HelmetProvider} from 'react-helmet-async';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";

import Company from "./about/Company";
import SocialLinks from "./about/SocialLinks";
import SaveTokenAndRedirect from "./header/Auth";
import MyRequests from "./crm/MyRequests";

import {MenuCardPage} from "./menu/MenuCards";
import {getAppRoutes} from "./utils/siteStructure"
import {Product} from "./product/ProductCard";
import {Service} from "./services/ServicesCards";
import {ConfiguratorSilos} from "./configurators/ConfiguratorSilos";
import {ConfiguratorAxles} from "./configurators/ConfiguratorAxles";
import {NewsProvider} from "./news/NewsContext";
import { ThemeProvider } from "./header/Header";
import siteStructure from "./siteStructure.json";

function App() {

    return (

        <HelmetProvider>
                <NewsProvider>
                    <ThemeProvider>
                        <Router>
                        <div>
                            <Header/>
                            <Routes>
                                {/*Меню Главное*/}
                                <Route path={`/`} element={<Main/>}/>

                                <Route path={`/requests`} element={<MyRequests/>}/>

                                {/*Меню О нас*/}
                                <Route path={`about`} element={<About/>}/>
                                <Route path={`about/contacts`} element={<Contacts/>}/>
                                <Route path={`about/company`} element={<Company/>}/>
                                <Route path={`about/socialLinks`} element={<SocialLinks/>}/>

                                {/*Лизинг*/}
                                <Route path={`lizing/Lizing_finance`} element={<LizingFinance/>}/>

                                {/*Новости*/}
                                <Route path={`news`} element={<NewsPreview/>}/>
                                <Route path={`news/*`} element={<News/>}/>

                                {/*Авторизация*/}
                                <Route path={`/auth/saveTokenAndRedirect`} element={<SaveTokenAndRedirect/>} />

                                {/*Конфигураторы*/}
                                <Route path={`/configurator/silos`} element={<ConfiguratorSilos/>} />
                                <Route path={`/configurator/axle`} element={<ConfiguratorAxles/>} />


                                {/*Меню, Товары, Услуги*/}
                                {getAppRoutes(siteStructure).map(e => {
                                    if (e.type === "menu") {
                                        return (
                                            <Route key={e.url} path={e.url} element={<MenuCardPage path={e.url} />} />
                                        );
                                    }
                                    if (e.type === "product" && e.property) {
                                        return (
                                            <Route key={e.url} path={e.url} element={<Product path={e.url} />} />
                                        );
                                    }
                                    if (e.type === "service") {
                                        return (
                                            <Route key={e.url} path={e.url} element={<Service />} />
                                        );
                                    }
                                    return null;
                                })}

                            </Routes>
                            <MobileBottomBar/>
                        </div>
                        </Router>
                    </ThemeProvider>
                </NewsProvider>
        </HelmetProvider>

    )
}


export default App;